<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <div class="flex align-items-center mb-3">
    <span class="p-input-icon-left flex-grow-1 mr-3">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        (input)="pagesTable.filterGlobal($any($event).target.value, 'contains')"
        placeholder="Search pages"
      />
    </span>
    <button
      pButton
      pRipple
      type="button"
      label="New page"
      icon="pi pi-plus"
      class="p-button-rounded flex-shrink-0"
      (click)="onAddPage()"
    ></button>
  </div>

  <p-table
    #pagesTable
    [value]="visiblePages(account.data?.content)"
    [globalFilterFields]="['title', 'path']"
    styleClass="mt-3 p-datatable-striped"
    dataKey="_meta.id"
    responsiveLayout="scroll"
    [paginator]="true"
    [rows]="20"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Page</th>
        <th>Address</th>
        <th>Sections</th>
        <th>Published</th>
        <th style="width: 12rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-page>
      <tr>
        <td>
          <strong>{{ page.title || '(untitled)' }}</strong>
          <i *ngIf="page.locked" class="pi pi-lock text-500 ml-2" style="font-size: 0.8rem"
             title="This page's address is part of the live sitemap and can't change"></i>
        </td>
        <td class="font-mono text-sm">{{ page.path }}</td>
        <td>{{ sectionCount(page) }}</td>
        <td>
          <i *ngIf="page.published === true" class="pi pi-check app-text-ok" title="Published"></i>
          <i *ngIf="page.published !== true" class="pi pi-pencil text-500" title="Draft — the site shows its built-in version"></i>
        </td>
        <td>
          <button
            pButton pRipple type="button" icon="pi pi-pencil"
            (click)="onEditPage(page)"
            class="p-button-rounded p-button-text" title="Edit"
          ></button>
          <!-- Scoped publish: ships THIS page only. -->
          <button
            pButton pRipple type="button"
            [icon]="publishingSlug === pageSlug(page.path) ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-upload'"
            (click)="onPublishPage(page)"
            [disabled]="!page.path || !!publishingSlug"
            class="p-button-rounded p-button-text"
            [title]="!page.path ? 'Give the page an address first' : 'Publish just this page to the staging preview'"
          ></button>
          <button
            pButton pRipple type="button" icon="pi pi-trash"
            (click)="onDeletePage(page)"
            [disabled]="page.locked"
            class="p-button-rounded p-button-danger p-button-text"
            [title]="page.locked ? 'Core site pages can\'t be removed' : 'Remove'"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="p-text-center muted p-py-5">
          <span *ngIf="!loadFailed">
            No pages yet. They appear here once seeded from the website (see
            picaluna-v3-integration-PAGE-CMS.md), or use "New page".
          </span>
          <span *ngIf="loadFailed" class="app-text-overdue">
            <i class="pi pi-exclamation-triangle mr-2"></i>
            The website content couldn't be loaded, so this list is empty because of an error — not
            because there are no pages. Close and reopen to try again.
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p *ngIf="regionPageCount(account.data?.content) > 0" class="text-500 text-sm mt-2">
    {{ regionPageCount(account.data?.content) }} region/suburb page(s) not listed here — design and edit
    them from Website → Regions or Website → Suburbs (each row's pencil).
  </p>

</ng-container>

<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
